export default "__VITE_ASSET__Dp4GoJ2h__"